import styled from 'styled-components'

import { helpers } from '../../../styles/theme'

type Props = {
	show: boolean
	showInvalid?: boolean
}

export const ChangedIndicator = styled.div<Props>`
	background-color: ${({ showInvalid }) => (showInvalid ? helpers.color.input.changeIndicatorError : helpers.color.input.changeIndicator)};
	width: 2px;
	height: 100%;
	position: absolute;
	inset: 0;
	border-top-left-radius: 3px;
	border-bottom-left-radius: 3px;
	visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
	opacity: ${({ show }) => (show ? 1 : 0)};

	transition: opacity 0.15s ease-in-out;
`
